import Configuration from './config/Configuration.js';

export default class PauseOverlay {
    /**
     * Initialize Pause overlay
     * @param {Object} customData
     */
    static init(customData) {
        const maxReccomendation = 3;

        if (typeof (customData.pauseOverlay) === 'undefined') {
            return false;
        }
        const data = customData.pauseOverlay;

        if (Configuration.get('version')) {
            document.getElementById('version').innerHTML = 'Version: ' + Configuration.get('version');
        }

        if (data.title) {
            document.getElementById('header-title').innerHTML = data.title;
        } else {
            document.getElementById('header-title').innerHTML = '';
        }
        if (data.description) {
            document.getElementById('header-description').innerHTML = data.description;
        } else {
            document.getElementById('header-description').innerHTML = '';
        }
        if (data.thumbnailUrl) {
            const img = document.createElement('img');
            img.src = data.thumbnailUrl;
            const thumbNode = document.getElementById('header-thumb');
            // Remove old images
            while (thumbNode.firstChild) {
                thumbNode.removeChild(thumbNode.firstChild);
            }
            thumbNode.appendChild(img);
        } else {
            const thumbNode = document.getElementById('header-thumb');
            // Remove old images
            while (thumbNode.firstChild) {
                thumbNode.removeChild(thumbNode.firstChild);
            }
        }

        if (data.next) {
            if (data.next.title) {
                document.getElementById('next-title').innerHTML = data.next.title;
            } else {
                document.getElementById('next-title').innerHTML = '';
            }
            if (data.next.subtitle) {
                document.getElementById('next-subtitle').innerHTML = data.next.subtitle;
            } else {
                document.getElementById('next-subtitle').innerHTML = '';
            }
            if (data.next.thumbnailUrl) {
                document.getElementById('next-thumb').style.backgroundImage = `url('${data.next.thumbnailUrl}')`;
            } else {
                document.getElementById('next-thumb').style.backgroundImage = 'none';
            }
            document.getElementById('next').style.display = 'inline-block';
        } else {
            document.getElementById('next').style.display = 'none';
        }

        if (data.recommendations) {
            const recommendNode = document.getElementById('recommendations-row');
            // Clear old recommendations
            while (recommendNode.firstChild) {
                recommendNode.removeChild(recommendNode.firstChild);
            }
            const recommendationlength = (
                data.recommendations.length
                && data.recommendations.length <= maxReccomendation
            ) ? data.recommendations.length : maxReccomendation;
            for (let i = 0; i < recommendationlength; i += 1) {
                const parentDiv = document.createElement('div');
                parentDiv.className = 'recommendations-thumb';
                if (data.recommendations[i].thumbnailUrl) {
                    parentDiv.style.backgroundImage = `url('${data.recommendations[i].thumbnailUrl}')`;
                }
                const textDiv = document.createElement('div');
                textDiv.className = 'recommendations-text';

                if (data.recommendations[i].title) {
                    const titleSpan = document.createElement('span');
                    titleSpan.className = 'recommendations-title';
                    titleSpan.innerHTML = data.recommendations[i].title;
                    textDiv.appendChild(titleSpan);
                }

                if (data.recommendations[i].subtitle) {
                    const subtitleSpan = document.createElement('span');
                    subtitleSpan.className = 'recommendations-subtitle';
                    subtitleSpan.innerHTML = data.recommendations[i].subtitle;
                    textDiv.appendChild(subtitleSpan);
                }

                parentDiv.appendChild(textDiv);
                recommendNode.appendChild(parentDiv);
                document.getElementById('recommendations').style.display = 'inline-block';
            }
        } else {
            document.getElementById('recommendations').style.display = 'none';
        }
        return true;
    }

    /**
     * Show pause Modal
     */
    static show() {
        document.getElementById('pauseModal').style.display = 'block';
    }

    /**
     * Hide pause Modal
     */
    static hide() {
        document.getElementById('pauseModal').style.display = 'none';
    }
}
